import { isValidPhoneExt, phoneNoExpExt } from '@/validators/phone'

export default {
  data () {
    return {
      knownNDCs: [
        '1501',
        '1502',
        '1505',
        '1508',
        '1510',
        '1511',
        '1512',
        '1513',
        '1514',
        '1515',
        '1516',
        '1517',
        '1518',
        '1519',
        '1520',
        '1521',
        '1522',
        '1523',
        '1525',
        '1526',
        '1531',
        '1551',
        '1555',
        '1556',
        '1563',
        '1566',
        '1567',
        '1570',
        '1573',
        '1575',
        '1576',
        '1577',
        '1578',
        '1579',
        '1588',
        '1590',
        '155',
        '160',
        '162',
        '163',
        '170',
        '171',
        '172',
        '173',
        '174',
        '175',
        '176',
        '177',
        '178',
        '179'
      ]
    }
  },
  mounted () {
    this.msisdnFormatted()
  },
  methods: {
    msisdnFormatted () {
      let cleanedNumber = this.msisdn.replace(/([^0-9+-])/g, '').trim()

      if (cleanedNumber) {
        if (!isValidPhoneExt(cleanedNumber)) {
          if (cleanedNumber.startsWith('49')) {
            cleanedNumber = '+' + cleanedNumber
          }

          const ndcMatch = this.knownNDCs.find(ndc => cleanedNumber.startsWith(ndc))
          if (ndcMatch) {
            cleanedNumber = '+49' + cleanedNumber
          }
        }

        if (isValidPhoneExt(cleanedNumber)) {
          const partCountryCode = cleanedNumber.replace(phoneNoExpExt, '$2')
          const partPrefix = cleanedNumber.replace(phoneNoExpExt, '$5')
          const partNo = cleanedNumber.replace(phoneNoExpExt, '$6')

          let formatted = (partCountryCode + (partCountryCode !== '0' ? ' ' : '') + partPrefix + ' ' + partNo).trim()

          if (!formatted.startsWith('+')) {
            if (formatted.startsWith('00')) {
              formatted = '+' + formatted.slice(2)
            } else if (formatted.startsWith('0')) {
              formatted = '+49' + formatted.slice(1)
            } else {
              formatted = '+49' + formatted
            }
          }

          cleanedNumber = formatted
        }
      } else {
        cleanedNumber = ''
      }
      this.msisdn = cleanedNumber
    }
  }
}
